import { defineTokens } from "@chakra-ui/react"

export const fontFamiliesHeadings = "var(--gil-font-fraunces), Georgia, serif"

export const fontFamiliesBody =
  "var(--gil-font-geist), ui-sans-serif, system-ui, sans-serif"

export const fontFamiliesCode =
  'var(--gil-font-fira-code), "Fira Mono", Consolas, Menlo, Monaco, "Andale Mono", "Ubuntu Mono", monospace'

export const fontFamiliesMono =
  'var(--gil-font-fira-code), SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'

export const fonts = defineTokens.fonts({
  heading: { value: fontFamiliesHeadings },
  body: { value: fontFamiliesBody },
  code: { value: fontFamiliesCode },
  mono: { value: fontFamiliesMono },
})
